module.exports = __webpack_public_path__ + "img/41.91b3c540.png";